"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/MXFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_163)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_163`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M18 0H-6V23.9509H30V0H18Z",
					fill: "#DC2339"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0H6V24H-6V0Z",
					fill: "#11865D"
				}),
				/* @__PURE__ */ n("path", {
					d: "M6 0H18V24H6V0Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M7.74023 12.014C7.74023 13.5298 8.54725 14.9404 9.86655 15.6982C10.2736 15.9368 10.7929 15.7965 11.0315 15.3895C11.2701 14.9825 11.1297 14.4632 10.7227 14.2246C9.92971 13.7684 9.4455 12.9263 9.4455 12.014C9.4455 11.5439 9.06655 11.1649 8.59637 11.1649C8.1262 11.1649 7.74023 11.5439 7.74023 12.014ZM14.2946 15.6C15.5227 14.8211 16.2595 13.4667 16.2595 12.014C16.2595 11.5439 15.8806 11.1649 15.4104 11.1649C14.9402 11.1649 14.5613 11.5439 14.5613 12.014C14.5613 12.8842 14.1192 13.6982 13.3823 14.1684C12.9823 14.414 12.856 14.9333 13.0946 15.3404C13.3332 15.7474 13.8595 15.8667 14.2665 15.6281C14.2665 15.614 14.2806 15.607 14.2946 15.6Z",
					fill: "#8C9157"
				}),
				/* @__PURE__ */ n("path", {
					d: "M11.9999 13.7193C12.9417 13.7193 13.7052 12.5757 13.7052 11.1649C13.7052 9.75417 12.9417 8.61053 11.9999 8.61053C11.0582 8.61053 10.2947 9.75417 10.2947 11.1649C10.2947 12.5757 11.0582 13.7193 11.9999 13.7193Z",
					fill: "#C59262"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_163`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as MXFlag };
